import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=ca918dc4&scoped=true&"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca918dc4",
  null
  
)

export default component.exports